import React from 'react';
import { InView as BaseInView } from 'react-intersection-observer';
import PropTypes from 'prop-types';

export const InView = ({ children, triggerOnce, ...extraProps }) => {
  // We want to always assume images are out of view coming from the server.
  if (__SERVER__) {
    return children({
      inView: false,
    });
  }

  // We do not want to hide images if IntersectionObserver is not supported.
  if (!('IntersectionObserver' in window)) {
    return children({
      inView: true,
    });
  }

  return (
    <BaseInView triggerOnce={triggerOnce} {...extraProps}>
      {children}
    </BaseInView>
  );
};

InView.propTypes = {
  children: PropTypes.func.isRequired,
  triggerOnce: PropTypes.bool,
};
